import React, { useState } from 'react';

import { BsBookmark } from 'react-icons/bs';
import {
  AiFillLike,
  AiOutlineClockCircle,
  AiOutlineLike,
} from 'react-icons/ai';

import OngoingCourse from '../../services/course/models/ongoing-course-interface';

import {
  Container,
  BookmarkButton,
  CompletionPercentage,
  Coursefooter,
  CourseLikes,
  CourseTime,
} from './style';
import ProgressBar from '../ProgressBar';
import { useHistory } from 'react-router-dom';
import { addBookMark, removeBookMark } from '../../services/bookmark';
import { toast } from 'react-toastify';
import { addLike, removeLike } from '../../services/like';
import { secondsToTimeText } from '../../helpers/time';

interface IOngoingCourseProps {
  course: OngoingCourse;
}

const OngoingCourseCard: React.FC<IOngoingCourseProps> = ({ course }) => {
  const history = useHistory();
  const [addedToList, setAddedToList] = useState(course.book_mark);
  const [addedToLike, setAddedToLike] = useState(course.addedToLike);

  const goToCourse = () => {
    history.push(`/trails/${course.trail_id}`);
  };

  const addToList = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (course) {
      try {
        const shouldAddToList = !course.book_mark;

        if (shouldAddToList) {
          await addBookMark(course.trail_id);
        } else {
          await removeBookMark(course.trail_id);
        }

        course.book_mark = shouldAddToList;
        setAddedToList(course.book_mark);
      } catch (e) {
        toast.error('Erro ao adicionar curso aos favoritos.');
      }
    }
  };

  return (
    <Container onClick={goToCourse}>
      <div>
        {course.thumbnail ? (
          <img src={course.thumbnail} alt="Course" />
        ) : (
          <div className="image" />
        )}
        <ProgressBar
          completionPercentage={Math.floor(course.progress * 100)}
          width={294.4}
        />

        <h4>{course.name}</h4>

        <BookmarkButton onClick={addToList}>
          <BsBookmark
            size={24}
            color="#FFF"
            className={`${addedToList && 'favorite'}`}
          />
        </BookmarkButton>
        <CompletionPercentage>{`${Math.floor(
          course.progress * 100,
        )}%`}</CompletionPercentage>
      </div>

      <Coursefooter>
        <CourseTime>
          <AiOutlineClockCircle size={20} />
          <span>{secondsToTimeText(course.duration)}</span>
        </CourseTime>
        <span className="divider" />
        <CourseLikes>
          {addedToLike ? (
            <AiFillLike color="#555" />
          ) : (
            <AiOutlineLike color="#555" />
          )}

          <span>
            {course.likes.count &&
              `${course.likes.count} ${
                course.likes.count === 1 ? 'curtida' : 'curtidas'
              }`}
          </span>
        </CourseLikes>
      </Coursefooter>
    </Container>
  );
};

export default OngoingCourseCard;
